import { SpeedInsights } from '@vercel/speed-insights/next';

import { currentOrigin } from '@glass/env/modules/origins/constants';

function SpeedInsightsScript() {
  // Disable in development to avoid 404 errors
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.log('[SpeedInsights] Disabled in development environment');
    return null;
  }

  if (
    !process.env.NEXT_PUBLIC_SPEED_INSIGHTS_SAMPLE_RATE ||
    process.env.NEXT_PUBLIC_SPEED_INSIGHTS_SAMPLE_RATE === '0'
  ) {
    return null;
  }

  const sampleRate = parseFloat(process.env.NEXT_PUBLIC_SPEED_INSIGHTS_SAMPLE_RATE) || 0;
  const endpoint = `${currentOrigin}/_vercel/speed-insights/vitals`;
  const scriptSrc = `${currentOrigin}/_vercel/speed-insights/script.js`;
  const isDebugEnabled = process.env.NEXT_PUBLIC_DEBUG === 'speed-insights' ? true : undefined;

  return (
    <SpeedInsights
      debug={isDebugEnabled}
      endpoint={endpoint}
      sampleRate={sampleRate}
      scriptSrc={scriptSrc}
    />
  );
}

export default SpeedInsightsScript;
